import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface UpdateEventGuest {
	uriParams: Api.Operations['updateEventGuest']['parameters']['path']
	body: NonNullable<
		Api.Operations['updateEventGuest']['requestBody']
	>['content']['application/json']
	response: Api.Operations['updateEventGuest']['responses']['202']
}

export const updateEventGuest = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<UpdateEventGuest>(
		{
			method: 'patch',
			url: '/events/{eventId}/guests/{email}',
			...overideConfig,
		},
		axiosInstance,
	)
